
function addToCart(artnr, amount) {
    document.addtocart.target = "";
    document.addtocart.addtocartartid.value = artnr;
    document.addtocart.addtocartamount.value = amount;
    document.addtocart.submit();
}
function addToCartAjax(artnr, amount, catalogpartner, tmp_idx_catalog_ids, articleview_ids) {
    disablePageOnReload(output['t_artikel_wird_in_warenkorb_uebernommen']);
    replaceOnLoadGIF();
    var element_id;
    if (l_user['release_3x_enabled'] == 'Y')
        element_id = "zone-basket";
    else
        element_id = "addToCartAjax";

    $.ajax(
        {
            url: "ajax-backend/addToCart.php?addtocartartid=" + artnr + "&addtocartamount=" + amount + "&sid=" + sid + "&catalogpartner=" + catalogpartner + "&tmp_idx_catalog_ids=" + tmp_idx_catalog_ids + "&articleview_ids=" + articleview_ids,
            context: document.getElementById('' + element_id),
            cache: false,
            success: function (reloadCart) {
                try {
                    var response = jQuery.parseJSON(reloadCart);
                    if(response instanceof Object){
                        notification.showMessages(response);
                        activeCart.getCartInfo();
                    }
                } catch (e) {
                    // no JSON ....
                }
                if ($.trim($("#" + element_id).text()) != "") {
                    $("#" + element_id).replaceWith(reloadCart);
                } else {
                    $("#" + element_id).append(reloadCart);
                }
                enablePageOnReload();
            }
        }).error(function () {
        alert(output['t_artikel_kann_nicht_in_den_warenkorb_gelegt_werden'] + " (a)");
    })
}

